<template>
  <div class="product-detail" ref="productDetailContentWrap">
    <div
      ref="productDetailContent"
      class="product-detail-content"
      v-if="
        isReadCpProductExt &&
        item.CP_PRODUCT_EXT &&
        item.CP_PRODUCT_EXT.CONTENT &&
        Array.isArray(item.CP_PRODUCT_EXT.CONTENT) &&
        item.CP_PRODUCT_EXT.CONTENT.length
      "
    >
      <prop-item
        v-for="(detail, index) in item.CP_PRODUCT_EXT.CONTENT"
        :key="detail.ID + detail.NAME + index"
        :detail="detail"
        @chooseProp="chooseProp"
      ></prop-item>
    </div>
    <div class="product-detail-content" v-else-if="isReadProductIco">
      <span class="product-detail-item">
        <img
          v-if="item.PRODUCT_ICON"
          class="product-detail-item-img center"
          :src="
            +gameId === 2
              ? getBeautyProductIco(item.PRODUCT_ICON)
              : item.PRODUCT_ICON
          "
          alt=""
          @error="beautyProductIcoError($event, item.PRODUCT_ICON)"
        />
        <img
          v-else
          class="product-detail-item-img center"
          :src="getGamePropIco()"
          alt=""
        />
      </span>
    </div>
  </div>
</template>

<script>
import IScroll from '@utiles/iscroll.js';
import PropItem from '@components/officialStore/product/PropItem.vue';
import propImg from '@mixins/officialStore/propImg';
import { mapState } from 'vuex';
export default {
  name: 'PropImg',
  mixins: [propImg],
  props: ['item'],
  data() {
    return {
      scroll: null
    };
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId
    }),
    isReadCpProductExt() {
      return this.$store.getters.gameInfoConfig.isReadCpProductExt;
    },
    isReadProductIco() {
      return this.$store.getters.gameInfoConfig.isReadProductIco;
    }
  },
  mounted() {
    if (
      this.item.CP_PRODUCT_EXT &&
      this.item.CP_PRODUCT_EXT.CONTENT &&
      Array.isArray(this.item.CP_PRODUCT_EXT.CONTENT) &&
      this.item.CP_PRODUCT_EXT.CONTENT.length
    ) {
      this.$nextTick(() => {
        this.initScroll();
      });
    }
  },
  methods: {
    initScroll() {
      if (
        !this.scroll &&
        this.item &&
        this.item.CP_PRODUCT_EXT &&
        this.item.CP_PRODUCT_EXT.CONTENT &&
        Array.isArray(this.item.CP_PRODUCT_EXT.CONTENT) &&
        this.item.CP_PRODUCT_EXT.CONTENT.length
      ) {
        let width = 106 * this.item.CP_PRODUCT_EXT.CONTENT.length;
        this.$refs.productDetailContent.style.width = width + 'px';
        this.scroll = new IScroll(this.$refs.productDetailContentWrap, {
          mouseWheel: true,
          scrollX: true,
          tap: true
        });
      } else if (this.scroll) {
        this.scroll.refresh();
      }
    },
    chooseProp(detail) {
      this.$emit('chooseProp', detail);
    }
  },
  components: {
    PropItem
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.product-detail {
  overflow: -moz-scrollbars-none;
  overflow-x: scroll;
  overflow-y: auto;
  width: 449px;
  height: 96px;
  white-space: nowrap;

  touch-action: pan-y;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }
  &-content {
    display: flex;
    flex-wrap: nowrap;
  }
  &-item {
    position: relative;
    flex-shrink: 0;
    margin-right: 8px;
    background-size: cover;
    @psetbg ('prop-item-bg.png');
    &-num {
      position: absolute;
      right: 5px;
      top: 5px;
      font-size: 17px;
      color: #e8e8e8;
    }
    &-img {
      position: absolute;
      left: 50%;
      bottom: 6px;
      width: 73px;
      transform: translateX(-50%);
      &.center {
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .product-detail {
    width: 378px;
  }
}
</style>
